'use strict';

import { __ } from '@wordpress/i18n';

export default class MyAccount {
    #container;
    #text;
    constructor() {
        this.#container = document.querySelector('.wc-block-components-notice-banner');
        if(this.#container){
            this.updateBannerText();

        }
    }

    updateBannerText() {
        this.#text = this.#container.querySelector('div.wc-block-components-notice-banner__content');
        if (this.#text) {
            const childNodes = Array.from(this.#text.childNodes);

            childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    let currentText = node.nodeValue;
                    let translatedText = __('No donations or payments have been made yet.', 'nitzanim');
                    let updatedText = currentText.replace(/No order has been made yet\./, translatedText);
                    node.nodeValue = updatedText;
                }
            });
        }
    }
}

